import { render } from "./MobileMenuBookings.vue?vue&type=template&id=523c4fc9"
import script from "./MobileMenuBookings.vue?vue&type=script&lang=js"
export * from "./MobileMenuBookings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__